// @flow

// Constants
export { ServiceActionTypes } from './constants';

// Components
export { default as AppBanner } from './components/AppBanner';
export { SmartAppBanner } from './components/AppBanner';
export { default as ServiceDropdown } from './components/ServiceDropdown';

// Contexts
export {
  AllServicesContext,
  AllServicesProvider,
  useAllServices,
  WithAllServices,
} from './contexts/AllServicesContext';

// Utils
import * as utilsBase from './utils';
export const utils = { ...utilsBase };
export { default as toLegacyCompatibleService } from './utils/toLegacyCompatibleService';
export { default as getAssociatedService } from './utils/getAssociatedService';
export { default as isLiveDataRequired } from './utils/isLiveDataRequired';
export { default as actionMeta } from './utils/actionMeta';
export { default as actionName } from './utils/actionName';
export { default as actionNoun } from './utils/actionNoun';
export { default as isOauth } from './utils/isOauth';
export { default as hasUpfrontFields } from './utils/hasUpfrontFields';
export { default as getServiceName } from './utils/getServiceName';
export { default as getServiceNameFromApi } from './utils/getServiceNameFromApi';

// Types
export type {
  Service,
  ServiceAction,
  ServiceActionType,
  ServiceField,
  SelectListItem,
  ServicesMap,
  ServiceFromSSR,
} from './types';

// GraphQL Queries
export { default as fullServiceById } from './graphql/query/fullServiceById';
export { default as servicesByIds } from './graphql/query/servicesByIds';

// GraphQL Fragments
import * as _fragments from './graphql/fragment/';
export const fragments = _fragments;
